import styled from 'styled-components';
import { rem } from 'polished';

const StyledTitle = styled.h1`
  color: ${props => props.theme.colors.dark_2};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  font-weight: initial;
  margin: 0 0 ${rem('25px')};
  line-height: normal;
  @media (min-width: ${props => props.theme.mediaqueries.tablet}) {
    font-size: ${rem('20px')};
    margin: 0 0 ${rem('25px')};
    text-align: center;
  }
`;

export { StyledTitle };
